module.exports = __webpack_public_path__ + "img/extractTermsLoading.594aacb6.gif";